import { MapPin } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { MARKETS } from "../constants/markets";

/**
 * Reusable "Choose Your Market" dropdown.
 *
 * Props:
 *   value: string ("" means All Markets)
 *   onChange: (newValue: string) => void
 *   variant: "hero" | "filter"
 *   testId: optional, defaults to "market-select"
 */
const MarketSelect = ({
  value = "",
  onChange,
  variant = "filter",
  testId = "market-select",
  placeholder = "Choose your market",
}) => {
  const handleChange = (v) => {
    onChange?.(v === "all" ? "" : v);
  };

  const triggerClassName =
    variant === "hero"
      ? "h-12 bg-white border-2 border-slate-200 hover:border-primary transition-colors shadow-sm"
      : "h-12";

  return (
    <Select value={value || "all"} onValueChange={handleChange}>
      <SelectTrigger
        className={triggerClassName}
        data-testid={testId}
        aria-label="Choose your market"
      >
        <MapPin className="w-4 h-4 mr-2 text-primary flex-shrink-0" />
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="market-option-all">All Markets</SelectItem>
        {MARKETS.map((m) => (
          <SelectItem
            key={m.value}
            value={m.value}
            data-testid={`market-option-${m.value.replace(/\s+/g, "-")}`}
          >
            {m.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default MarketSelect;
